import {Component, DOCUMENT, ElementRef, Inject, OnDestroy, Renderer2} from '@angular/core';
import {NavigationEnd, NavigationStart, Router, RouterLink, RouterOutlet} from '@angular/router';
import {NavigationComponent} from './shared/navigation/navigation.component';
import {provideIcons} from '@ng-icons/core';
import {heroMagnifyingGlass} from '@ng-icons/heroicons/outline';
import {HeaderComponent} from './shared/header/header.component';
import {ToastComponent} from './shared/toast/toast.component';
import {Subscription} from 'rxjs';
import {NavigationService} from '../shared/navigation.service';
import {HeaderService} from '../shared/header.service';
import {HeaderVariant} from '../enums/header-variant';
import {NgClass} from '@angular/common';
import {ContainerComponent} from './container/container.component';
import {IonRouterLinkWithHref} from '@ionic/angular/standalone';
import {PlatformService} from '../shared/platform.service';
import {CookieConsentService} from '../shared/cookie-consent.service';
import {StatusBar, Style} from '@capacitor/status-bar';
import {EdgeToEdge} from '@capawesome/capacitor-android-edge-to-edge-support';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, NavigationComponent, ToastComponent, NgClass, ContainerComponent, IonRouterLinkWithHref, RouterLink],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  viewProviders: [provideIcons({heroMagnifyingGlass})]
})
export class AppComponent implements OnDestroy {
  protected headerVariant: HeaderVariant = HeaderVariant.BIG;
  protected readonly headerVariantEnum = HeaderVariant;
  private _subscriptions: Subscription[] = [];

  constructor(private _router: Router, private _navigationService: NavigationService, private _headerService: HeaderService,
              private _platformService: PlatformService, private _cookieConsentService: CookieConsentService,
              private _elementRef: ElementRef,
              private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document) {
    const subscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._headerService.setTitle(null);
        this._headerService.setVariant(HeaderVariant.BIG);
      }
      if (event instanceof NavigationEnd) {
        this._navigationService.navigated = true;
        this.headerVariant = this._headerService.variant$.value;
      }
    });
    this._subscriptions.push(subscription);
    if (!this._platformService.isServer() && this._platformService.isNative()) {
      this._renderer2.addClass(this._document.body, 'native-app');
    }
    if (!this._platformService.isServer()) {
      this._initCookieConsent();
      if (this._platformService.isAndroid()) {
          EdgeToEdge.setBackgroundColor({color: '#000000'}).then(r => console.log('r', r)).catch(e => console.error('e', e));
          StatusBar.setStyle({style: Style.Dark});
      }
    }
  }

  ngOnDestroy() {
    this._unsubscribeSubscriptions();
  }

  private _unsubscribeSubscriptions() {
    this._subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private async _initCookieConsent() {
    await this._cookieConsentService.initConsent();
    setTimeout(() => {
      this._cookieConsentService.initConsentManager();
    }, 2000);
  }
}
